var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/trash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.125 3.73828C11.0438 3.53203 8.95 3.42578 6.8625 3.42578C5.625 3.42578 4.3875 3.48828 3.15 3.61328L1.875 3.73828",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.31641 3.10625L5.45391 2.2875C5.55391 1.69375 5.62891 1.25 6.68516 1.25H8.32266C9.37891 1.25 9.46016 1.71875 9.55391 2.29375L9.69141 3.10625",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7773 5.71289L11.3711 12.0066C11.3023 12.9879 11.2461 13.7504 9.50234 13.7504H5.48984C3.74609 13.7504 3.68984 12.9879 3.62109 12.0066L3.21484 5.71289",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.45312 10.3125H8.53437",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.94141 7.8125H9.06641",
    stroke: "#0008C3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d07f2bc210625bacb758cf504346ede5.svg";
export { ForwardRef as ReactComponent };